import React from 'react';
import Countdown, { CountdownProps } from 'react-countdown';

export const PortfolioPoolCountdown = (props: CountdownProps) => {
  return (
    <Countdown
      renderer={({ formatted, days }) => {
        const { hours, minutes, seconds } = formatted;

        const showDays = days > 0;

        return (
          <>
            {showDays && <>{days}d </>}
            {hours}h {minutes}m {seconds}s
          </>
        );
      }}
      {...props}
    />
  );
};

export default PortfolioPoolCountdown;
